



import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetchData } from "../../hooks/useFtechData";
import Loader from "../../component/utilities/Loader";
import Header from "../../component/Header";
import JobSeekerStats from "./JobSeekerStats";
import SearchByLocation from "../home/SearchByLocation";

function JobTitleCounts() {
  const API_URL = `${process.env.REACT_APP_API_URL}job/alljob`;
  const { data, loading, errors } = useFetchData(API_URL);
  const [jobTitleData, setJobTitleData] = useState([]);
  const [jobStructures, setJobStructures] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJobTitle, setSelectedJobTitle] = useState("");
  const [currentView, setCurrentView] = useState("states");
  const [selectedState, setSelectedState] = useState("");
  const [selectedLGA, setSelectedLGA] = useState("");
  const navigate = useNavigate();

  // Process job data to compute nested structure by jobTitle, state, LGA, city
  useEffect(() => {
    if (data) {
      // Filter for Online jobs
      const onlineJobs = data.filter((job) => job.status === "Online");

      // Aggregate job counts in a nested structure
      const structures = onlineJobs.reduce((acc, job) => {
        const title = job.jobTitle;
        const state = job.state;
        const lga = job.localGovernment;
        const city = job.city;

        if (!acc[title]) {
          acc[title] = { total: 0, states: {} };
        }
        acc[title].total += 1;

        if (!acc[title].states[state]) {
          acc[title].states[state] = { count: 0, lgas: {} };
        }
        acc[title].states[state].count += 1;

        if (!acc[title].states[state].lgas[lga]) {
          acc[title].states[state].lgas[lga] = { count: 0, cities: {} };
        }
        acc[title].states[state].lgas[lga].count += 1;

        if (!acc[title].states[state].lgas[lga].cities[city]) {
          acc[title].states[state].lgas[lga].cities[city] = 0;
        }
        acc[title].states[state].lgas[lga].cities[city] += 1;

        return acc;
      }, {});

      setJobStructures(structures);

      // Convert to array for rendering cards (jobTitle and total only)
      const formattedData = Object.entries(structures).map(([title, info]) => ({
        jobTitle: title,
        total: info.total,
      }));

      // Sort by jobTitle for consistent display
      setJobTitleData(formattedData.sort((a, b) => a.jobTitle.localeCompare(b.jobTitle)));
    }
  }, [data]);

  const handleJobTitleClick = (jobTitle) => {
    setSelectedJobTitle(jobTitle);
    setCurrentView("states");
    setSelectedState("");
    setSelectedLGA("");
    setIsModalOpen(true);
  };

  const handleStateClick = (state) => {
    setSelectedState(state);
    setCurrentView("lgas");
  };

  const handleLGAClick = (lga) => {
    setSelectedLGA(lga);
    setCurrentView("cities");
  };

  const handleCityClick = (city) => {
    navigate(
      `/jobs?jobTitle=${encodeURIComponent(selectedJobTitle)}&state=${encodeURIComponent(selectedState)}&lga=${encodeURIComponent(selectedLGA)}&city=${encodeURIComponent(city)}`
    );
    setIsModalOpen(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (errors) {
    return (
      <div className="min-h-screen bg-gray-100 pt-16 sm:pt-20">
        <Header darkMode={true} />
        <div className="container mx-auto p-4">
          <p className="text-center text-red-600">Error fetching job data: {errors.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 pt-16 sm:pt-20">
      <Header darkMode={true} />
      {/* <div className="container mx-auto p-4">
        {jobTitleData.length > 0 ? (
          <div className="flex flex-wrap gap-4 justify-center">
            {jobTitleData.map((job, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg border border-gray-200 p-4 w-64 hover:bg-gray-50 transition-colors duration-200"
              >
                <h3
                  className="text-sm font-semibold text-gray-800 capitalize cursor-pointer hover:text-orange-500"
                  onClick={() => handleJobTitleClick(job.jobTitle)}
                >
                  {job.jobTitle}
                </h3>
                <p className="text-sm text-gray-600 mt-2">Available: {job.total}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-600">No online jobs found.</p>
        )}
      </div> */}



      <div className="container mx-auto p-4">
      <SearchByLocation/>
      <JobSeekerStats />
  {jobTitleData.length > 0 ? (
    <div className="grid grid-cols-3 gap-4 justify-center sm:flex sm:flex-wrap sm:gap-4 sm:justify-center">
      {jobTitleData.map((job, index) => (
        <div
          key={index}
          className="bg-white shadow-md rounded-lg border border-gray-200 p-4 w-full sm:w-64 hover:bg-gray-50 transition-colors duration-200"
        >
          <h3
            className="text-sm font-semibold text-gray-800 capitalize cursor-pointer hover:text-orange-500"
            onClick={() => handleJobTitleClick(job.jobTitle)}
          >
            {job.jobTitle}
          </h3>
          <p className="text-sm text-gray-600 mt-2">Available: {job.total}</p>
        </div>
      ))}
    </div>
  ) : (
    <p className="text-center text-gray-600">No online jobs found.</p>
  )}
</div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full max-h-96 overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold capitalize">{selectedJobTitle} Locations</h2>
              <button
                className="text-gray-600 hover:text-gray-800"
                onClick={() => setIsModalOpen(false)}
              >
                Close
              </button>
            </div>

            {currentView === "states" && (
              <ul className="space-y-2">
                {Object.entries(jobStructures[selectedJobTitle]?.states || {})
                  .sort(([a], [b]) => a.localeCompare(b))
                  .map(([state, info]) => (
                    <li
                      key={state}
                      className="cursor-pointer text-gray-800 hover:text-orange-500"
                      onClick={() => handleStateClick(state)}
                    >
                      {state} ({info.count})
                    </li>
                  ))}
              </ul>
            )}

            {currentView === "lgas" && (
              <div>
                <button
                  className="mb-4 text-gray-600 hover:text-gray-800"
                  onClick={() => setCurrentView("states")}
                >
                  Back to States
                </button>
                <ul className="space-y-2">
                  {Object.entries(jobStructures[selectedJobTitle]?.states[selectedState]?.lgas || {})
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([lga, info]) => (
                      <li
                        key={lga}
                        className="cursor-pointer text-gray-800 hover:text-orange-500"
                        onClick={() => handleLGAClick(lga)}
                      >
                        {lga} ({info.count})
                      </li>
                    ))}
                </ul>
              </div>
            )}

            {currentView === "cities" && (
              <div>
                <button
                  className="mb-4 text-gray-600 hover:text-gray-800"
                  onClick={() => setCurrentView("lgas")}
                >
                  Back to LGAs
                </button>
                <ul className="space-y-2">
                  {Object.entries(jobStructures[selectedJobTitle]?.states[selectedState]?.lgas[selectedLGA]?.cities || {})
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([city, count]) => (
                      <li
                        key={city}
                        className="cursor-pointer text-gray-800 hover:text-orange-500"
                        onClick={() => handleCityClick(city)}
                      >
                        {city} ({count})
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default JobTitleCounts;